import { useEffect, useRef } from "react";
import { sendStats, localDate } from "@/lib/reader";

const IDLE_MS = 3 * 60 * 1000;
const FLUSH_SECONDS = 30;

// Counts active reading time and narration listening time, sent in small batches.
export default function useReadingStats(bookId, listening) {
  const counts = useRef({ read: 0, listen: 0 });
  const lastActive = useRef(Date.now());
  const listeningRef = useRef(listening);
  listeningRef.current = listening;

  useEffect(() => {
    if (!bookId) return undefined;
    const bump = () => (lastActive.current = Date.now());
    const flush = () => {
      const { read, listen } = counts.current;
      if (!read && !listen) return;
      counts.current = { read: 0, listen: 0 };
      sendStats({ book_id: bookId, read_seconds: Math.min(read, 120), listen_seconds: Math.min(listen, 120), local_date: localDate() }).catch(() => {});
    };
    const tick = setInterval(() => {
      const c = counts.current;
      if (listeningRef.current) c.listen += 1;
      else if (!document.hidden && Date.now() - lastActive.current < IDLE_MS) c.read += 1;
      if (c.read + c.listen >= FLUSH_SECONDS) flush();
    }, 1000);
    const onHide = () => document.hidden && flush();
    ["scroll", "keydown", "pointerdown", "mousemove", "touchstart"].forEach((e) => window.addEventListener(e, bump, { passive: true }));
    document.addEventListener("visibilitychange", onHide);
    window.addEventListener("pagehide", flush);
    return () => {
      clearInterval(tick);
      flush();
      ["scroll", "keydown", "pointerdown", "mousemove", "touchstart"].forEach((e) => window.removeEventListener(e, bump));
      document.removeEventListener("visibilitychange", onHide);
      window.removeEventListener("pagehide", flush);
    };
  }, [bookId]);
}
